import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ValidationService } from '../../utils/Auth.js';
import Cookies from 'universal-cookie';
import './UserList.css'
import '../auth/Spinner.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { SOCIOS_APP_URL } from '../../data/GlobalConstants.js';
import { updateLastConnection } from '../../utils/api-abonado.js';
import { getMemberTypeKeys, hasBit } from '../../utils/memberTypes.js';

function UserList (props){
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [members, setMembers] = useState(props.members || []);
    const [email, setEmail] = useState(props.email || '');
    const [isSociosApp, setIsSociosApp] = useState(false);
    
    // Extraer parámetros de URL
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const status = queryParams.get('status');
    const dynamicURL = queryParams.get('dynamicURL');
    const singUpURL = queryParams.get('singUpURL');
    const memberType = queryParams.get('memberType');
    const hideId = queryParams.get('hideId') === 'true';
    const idBetis = queryParams.get('idBetis');

    const [lenguage, setLanguage] = useState('es');
    const [selectedItem, setSelectedItem] = useState(null);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {

        // Si solo hay un miembro, seleccionarlo automáticamente
        if (props.members && props.members.length === 1) {
            handleSelection(props.members[0].id_betis);
        }

        // Configuramos si es app de socios
        setIsSociosApp(props.url.includes(SOCIOS_APP_URL));
    }, [props.members]);

    function handleSelection (id_betis) {
        setSelectedItem(id_betis);
        setDisabled(false);
    }

    async function handleUser (){
        setIsLoading(true);
        const id = selectedItem;
        var selectedMember = members.filter((item) => item.id_betis === id);

        try {
            const JWTarray = await ValidationService.signJWT(selectedMember[0]);

            // Para el tiempo de vigencia de las cookies, vamos a diferenciar si es APP o web.
            // En caso de app, se habilitará para 30 días (2592000 segundos), en caso de web, 2 horas (7200 segundos)
            let maxAgeValue = 7200; // Valor por defecto para web
            if (isSociosApp) {
                maxAgeValue = 2592000; // Valor para app
            }
            
            const cookies = new Cookies();
            for ( var jwe of JWTarray) {
                if (jwe.Id !== "SSO-APP") {
                    cookies.set(jwe.Id, jwe.JWE, { path: '/' , maxAge: maxAgeValue, domain: '.realbetisbalompie.es'});
                }
                else {
                    var jweApp = jwe.JWE;
                }
            }

            await updateLastConnection(selectedMember[0].pk_id);

            if (memberType) {
                window.location.replace(`https://${props.url}/${memberType}/pago`);
            } else if (dynamicURL) {
                const [baseUrl, queryString] = dynamicURL.split('?');
                const encodedQueryString = queryString ? `?${encodeURIComponent(queryString)}` : '';
                window.location.replace(`https://${props.url}/${baseUrl}${encodedQueryString}`);    
            
            } else if (props.url !== 'App') {
                console.log(props.url);
                window.location.replace(`https://${props.url}`);
            } else {
                window.location.replace(`/app?token=${jweApp}`);
            }

        } catch (e) {
            throw new Error(e);
        }
        setIsLoading(false);
    }

    function formatDate(value){
        var date = new Date(value);
        var value = date.toLocaleDateString("es-ES");
        return value;
    }

    return  (
        <Container fluid className="containerList">
            <Row className="px-4 my-5">
                <h1 className='h1Identify green-text'>{t('h1Identify')}</h1>
                {isLoading && <div class="loader mb-3"></div>}
                <Col className='colList'>
                    {members.length > 1 && <p className='moreThanOneUser green-text'><b>{t('moreThanOneUser')}</b></p>}
                    <ListGroup as='ul'>
                        {members.map((user,index) =>
                            (
                                <Container>
                                    <ListGroup.Item as='li' className='listgroupItem' key={user.id_betis} active={user.id_betis === selectedItem} onClick={() => handleSelection(user.id_betis)} >
                                        <p><strong>{t('userType')}: </strong>{getMemberTypeKeys(user.id_tipo).map(key => t(key)).join(', ') || '-'}</p>
                                        <p><strong>{t('name')}: </strong>{user.name} {user.first_name} {user.last_name}</p>
                                        <p><strong>{t('birthdate')}: </strong> {formatDate(user.birthdate)}</p>
                                        {!hideId && hasBit(user.id_tipo, 1) && (
                                            <p><strong>{t('inputIDbetis')}: </strong> {user.pk_id}</p>
                                        )}
                                    </ListGroup.Item>
                                    <hr></hr>
                                </Container>
                            ))}
                    </ListGroup>
                    <Button type="button" className='btnLogin btnUserList' onClick={handleUser} disabled={disabled}>
                        {t('btnLogin')}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default UserList;
